// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".message-box {\n  height: calc(100% - 60px);\n}\n.message-box .message-top {\n  background: #fff;\n  padding: 0px 32px 16px 32px;\n  border-bottom: 1px solid #e8e8e8;\n}\n.message-box .message-body {\n  margin-top: 16px;\n  padding: 0 32px;\n}\n.message-box .el-tabs__header {\n  margin: 0;\n}\n.message-box .expand-table .el-table-column--selection .cell {\n  padding: 0 5px;\n  text-align: center;\n}", ""]);
// Exports
module.exports = exports;
